var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import Rates from './Rate';
import { cssClassMap } from '../../../../constants/SportCssMap';
import 'moment/locale/ru';
import 'moment/locale/en-gb';
import mainScoresFactory from './statistics/mainScores/mainScore';
import HeaderOutcomePlace from './header-outcome-place-config.json';
import MatchScoresAdapter from '../../../adapters/MatchScoresAdapter';
import Scores from '../../live/Scores';
import { winWithoutDraw } from './matchType';
import * as SportType from '../../../../constants/SportType';
import * as PeriodType from '../../../../constants/Period';
import { getPeriodInfo } from '../../event/statistics/utils';
import { FormattedMessage } from 'react-intl';
var showServeSpors = [SportType.TABLE_TENNIS, SportType.BEACH_VOLLEYBALL, SportType.BADMINTON, SportType.VOLLEYBALL];
var messages = defineMessages({
    grid_w1: {
        id: 'grid.w1',
        defaultMessage: 'П1'
    },
    grid_x: {
        id: 'grid.x',
        defaultMessage: 'X'
    },
    grid_w2: {
        id: 'grid.w2',
        defaultMessage: 'П2'
    },
    min: {
        id: 'grid.match-current-time.forward',
        defaultMessage: '{minute} мин.'
    },
});
var Match = /** @class */ (function (_super) {
    __extends(Match, _super);
    function Match() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Match.prototype.render = function () {
        var _this = this;
        var _a = this.props, match = _a.match, first = _a.first, outcome = _a.outcome, section = _a.section, gridLocalization = _a.gridLocalization, intl = _a.intl, client = _a.client;
        var sportId = match.get('sportId');
        var id = match.get('id');
        var channel = match.get('channel') || null;
        var stream = (channel !== null && channel.includes('url:'));
        if (match.get('type') === 2) {
            return (_jsx("div", __assign({ className: "item ".concat(cssClassMap[sportId]) }, { children: _jsx("div", __assign({ className: 'name' }, { children: _jsx(Link, __assign({ to: "/live/".concat(id) }, { children: _jsxs("span", __assign({ className: 'player' }, { children: [" ", match.get('name')] })) })) })) })));
        }
        var firstTeam = match.get('firstTeam');
        var secondTeam = match.get('secondTeam');
        var outcomesCount = match.get('outcomesCount');
        var notice = match.get('notice');
        var outcomeRates = outcome !== undefined ? outcome.get('rates').toArray() : [];
        var renderScores = [];
        var matchScoresIds = match.get('scores');
        var scoresMap = matchScoresIds.map(function (m) { return _this.props.scores.get(m); });
        var additionalScores = MatchScoresAdapter.getAdditionalScores(sportId, scoresMap);
        var mainScoresMap = mainScoresFactory(sportId, scoresMap);
        additionalScores.forEach(function (s, i) {
            renderScores.push(_jsx(Scores, { id: s, section: section }, i));
        });
        var ifFirst = first ? ' first' : '';
        var renderRates = [];
        var props = {
            section: section,
            gridLocalization: gridLocalization
        };
        if (outcomeRates.length === 0) {
            if (winWithoutDraw.find(function (m) { return m === match.get('sportId'); })) {
                renderRates.push(_jsx("div", __assign({ className: 'rate' }, { children: _jsx("span", __assign({ className: 'metka' }, { children: "--" })) }), '1'));
                renderRates.push(_jsx("div", __assign({ className: 'rate' }, { children: _jsx("span", __assign({ className: 'metka' }, { children: "--" })) }), '2'));
            }
            else {
                renderRates.push(_jsx("div", __assign({ className: 'rate' }, { children: _jsx("span", __assign({ className: 'metka' }, { children: "--" })) }), '1'));
                renderRates.push(_jsx("div", __assign({ className: 'rate' }, { children: _jsx("span", __assign({ className: 'metka' }, { children: "--" })) }), '2'));
                renderRates.push(_jsx("div", __assign({ className: 'rate' }, { children: _jsx("span", __assign({ className: 'metka' }, { children: "--" })) }), '3'));
            }
        }
        else {
            if (winWithoutDraw.find(function (m) { return m === match.get('sportId'); })) {
                renderRates.push(_jsx(Rates, __assign({ id: outcomeRates[0], first: first, outcomeName: intl.formatMessage(messages.grid_w1) }, props), '1'));
                renderRates.push(_jsx(Rates, __assign({ id: outcomeRates[1], first: first, outcomeName: intl.formatMessage(messages.grid_w2) }, props), '3'));
            }
            else {
                renderRates.push(_jsx(Rates, __assign({ id: outcomeRates[0], first: first, outcomeName: intl.formatMessage(messages.grid_w1) }, props), '1'));
                renderRates.push(_jsx(Rates, __assign({ id: outcomeRates[1], first: first, outcomeName: intl.formatMessage(messages.grid_x) }, props), '2'));
                renderRates.push(_jsx(Rates, __assign({ id: outcomeRates[2], first: first, outcomeName: intl.formatMessage(messages.grid_w2) }, props), '3'));
            }
        }
        var cls = winWithoutDraw.find(function (m) { return m === match.get('sportId'); }) ? ' win-without-draw' : '';
        var isClosed = match.get('isBlocked') ? ' item--is-closed' : '';
        var showFirstTeamServePossession = mainScoresMap.isFirstTeamServe !== undefined && mainScoresMap.isFirstTeamServe === true ||
            mainScoresMap.homeTeamPossession !== undefined && mainScoresMap.homeTeamPossession === true ||
            mainScoresMap.homeTeamServe !== undefined && mainScoresMap.homeTeamServe === true && showServeSpors.find(function (s) { return s === match.get('sportId'); });
        var showSecondTeamServePossesion = mainScoresMap.isSecondTeamServe !== undefined && mainScoresMap.isSecondTeamServe === true ||
            mainScoresMap.awayTeamPossession !== undefined && mainScoresMap.awayTeamPossession === true ||
            mainScoresMap.homeTeamServe !== undefined && mainScoresMap.awayTeamServe === true && showServeSpors.find(function (s) { return s === match.get('sportId'); });
        var pp1;
        var pp2;
        if (sportId === 30 && mainScoresMap.powerplay !== undefined) {
            if (mainScoresMap.powerplay.team === 1) {
                pp2 = 'PP';
            }
            if (mainScoresMap.powerplay.team === 2) {
                pp1 = 'PP';
            }
        }
        var showScores = (_jsxs("span", __assign({ className: 'sub sub-live' }, { children: [_jsxs("span", { children: [sportId !== SportType.FOOTBALL && renderScores.length > 0 &&
                            _jsxs("span", __assign({ style: { color: '#527A5B' }, className: 'item__additional-scores' }, { children: ["(", renderScores, ")"] })), mainScoresMap !== undefined &&
                            _jsxs("span", __assign({ className: 'item__serves', style: { paddingLeft: '3px' } }, { children: [mainScoresMap.firstTeamCurrentGame !== undefined && mainScoresMap.firstTeamCurrentGame, mainScoresMap.firstTeamCurrentGame !== undefined && _jsx("span", { children: ":" }), mainScoresMap.secondTeamCurrentGame !== undefined && mainScoresMap.secondTeamCurrentGame] })), _jsx("span", __assign({ className: 'sub__count' }, { children: outcomesCount }))] }), stream && (client.country === 'KG') && _jsx("button", { className: 'stream-img_btn' })] })));
        var showTotalScore = mainScoresMap !== undefined;
        if (sportId === SportType.FOOTBALL) {
            var periodInfo = getPeriodInfo(match, gridLocalization);
            var matchPhase = periodInfo.matchPhase;
            var showTime = matchPhase && (matchPhase === PeriodType.FIRST ||
                matchPhase === PeriodType.SECOND ||
                matchPhase === PeriodType.OVERTIME ||
                matchPhase === PeriodType.FIRST_EXTRA ||
                matchPhase === PeriodType.SECOND_EXTRA);
            var showPeriod = matchPhase && (matchPhase === PeriodType.NOT_STARTED ||
                matchPhase === PeriodType.FIRST_BREAK || matchPhase === PeriodType.SECOND_BREAK ||
                matchPhase === PeriodType.SECOND_BREAK || matchPhase === PeriodType.THIRD_BREAK ||
                matchPhase === PeriodType.FOURTH_BREAK || matchPhase === PeriodType.PENALTIES ||
                matchPhase === PeriodType.FINISHED);
            var minute = periodInfo.matchMinute;
            var values = { minute: minute };
            if (matchPhase === PeriodType.FINISHED) {
                showTotalScore = false;
            }
            showScores = (_jsxs("span", __assign({ className: 'sub sub-live' }, { children: [_jsxs("span", { children: [showPeriod && periodInfo.period, "\u00A0", showTime && _jsx(FormattedMessage, __assign({}, messages.min, { values: values }, { children: function (message) { return _jsx("span", __assign({ className: "current-time" }, { children: message })); } })), _jsx("span", __assign({ className: 'sub__count' }, { children: outcomesCount }))] }), stream && (client.country === 'KG') && _jsx("button", { className: 'stream-img_btn' })] })));
        }
        if (sportId === SportType.MARTIAL_ARTS) {
            var periodInfo = getPeriodInfo(match, gridLocalization);
            var matchPhase = periodInfo.matchPhase;
            showTotalScore = true;
            var showPeriod = [
                PeriodType.NOT_STARTED,
                PeriodType.FIRST,
                PeriodType.SECOND,
                PeriodType.THIRD,
                PeriodType.FOURTH,
                PeriodType.FIFTH,
                PeriodType.FINISHED
            ].includes(matchPhase);
            if (matchPhase === PeriodType.FINISHED) {
                showTotalScore = false;
            }
            showScores = (_jsx("span", __assign({ className: 'sub sub-live' }, { children: _jsxs("span", { children: [showPeriod && periodInfo.period, "\u00A0", _jsx("span", __assign({ className: 'sub__count' }, { children: outcomesCount }))] }) })));
        }
        if (renderScores.length === 0) {
            showTotalScore = false;
        }
        return (_jsx("div", __assign({ className: "item ".concat(cssClassMap[sportId]).concat(ifFirst).concat(isClosed) }, { children: _jsxs("div", { children: [_jsx("div", __assign({ className: "name".concat(cls) }, { children: _jsxs(Link, __assign({ to: "/live/".concat(id) }, { children: [_jsxs("span", __assign({ className: 'player' }, { children: [_jsxs("span", __assign({ className: 'player__team' }, { children: [showFirstTeamServePossession &&
                                                    _jsx("span", { className: "player__team__serve player__team__serve--active ".concat(cssClassMap[sportId]) }), firstTeam, " ", pp1 !== undefined && _jsxs("span", { children: ["(", pp1, ")"] })] })), _jsx("span", __assign({ className: 'player__main-score' }, { children: showTotalScore && mainScoresMap.firstTeamTotal }))] })), _jsxs("span", __assign({ className: 'player' }, { children: [_jsxs("span", __assign({ className: 'player__team' }, { children: [showSecondTeamServePossesion &&
                                                    _jsx("span", { className: "player__team__serve player__team__serve--active ".concat(cssClassMap[sportId]) }), secondTeam, " ", pp2 !== undefined && _jsxs("span", { children: ["(", pp2, ")"] })] })), _jsx("span", __assign({ className: 'player__main-score' }, { children: showTotalScore && mainScoresMap.secondTeamTotal }))] })), notice && _jsx("span", __assign({ className: 'sub' }, { children: notice })), showScores] })) })), _jsx("div", __assign({ className: "rates".concat(cls) }, { children: renderRates }))] }) })));
    };
    Match.propTypes = {
        gridLocalization: PropTypes.object.isRequired,
        section: PropTypes.string.isRequired,
        match: PropTypes.object.isRequired,
        outcome: PropTypes.object,
        intl: PropTypes.object.isRequired,
        first: PropTypes.bool
    };
    return Match;
}(React.Component));
var mapStateToProps = function (state, props) { return ({
    languageId: state.application.get('languageId'),
    match: state.application.getIn([props.section, 'matches', props.id]),
    scores: state.application.getIn([props.section, 'scores']),
    client: state.application.get('client'),
    outcome: state.application.getIn([props.section, 'outcomes']).find(function (m) {
        return m.get('matchId') === props.id && m.get('isHeader') === true && HeaderOutcomePlace[m.get('type')] === 1;
    }),
}); };
Match = connect(mapStateToProps)(Match);
export default injectIntl(Match);



// WEBPACK FOOTER //
// ./src/components/grid/common/sportsGrid/HighlightedLiveMatch.jsx